<template>
  <div class="partMeminfo">
    <el-form ref="form" :model="form" :rules="rules" label-width="140px">
      <el-row>
        <el-col :span="12" class="topTips">
          <label>基础信息</label>
        </el-col>
      </el-row>
      <el-row class="baseinfo">
        <el-row>
          <el-col :span="12" v-if="$route.path.split('/')[2] === 'addPartmem'">
            <el-form-item label="手机号" prop="serviceRevise.tel">
              <el-input
                placeholder="请输入手机号"
                v-model="form.serviceRevise.tel"
                style="width:200px"
              ></el-input>
              <el-button type="primary" @click="searchTel">调取</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="户籍地址">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年龄">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现居地址">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="紧急联系人">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工作性质">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="紧急联系电话">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="主攻专业">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="已获资质">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="擅长项目">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="认证门店">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="认证时间">呵呵</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="认证码">呵呵</el-form-item>
          </el-col>
        </el-row>
      </el-row>
      <el-row>
        <el-col :span="12" class="topTips">
          <label>信息确认</label>
        </el-col>
      </el-row>
      <el-row v-if="$route.path.split('/')[2] === 'viewPartmem'">
        <el-col :span="12">
          <el-form-item>本人与身份证信息是否一致</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>手法、资质证书真实性、服务能力认可</el-form-item>
        </el-col>
      </el-row>
      <el-row v-else>
        <el-col :span="12">
          <el-form-item prop="serviceRevise.confirmTrue" class="checkBoxcom">       
            <span class="red">*</span>               
            <el-checkbox v-model="form.serviceRevise.confirmTrue" label="1" :disabled="$route.path.split('/')[2] !== 'addPartmem'">本人与身份证信息是否一致</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="serviceRevise.confirmCerti" class="checkBoxcom">
            <span class="red">*</span>
            <el-checkbox v-model="form.serviceRevise.confirmCerti" label="1" :disabled="$route.path.split('/')[2] !== 'addPartmem'">手法、资质证书真实性、服务能力认可</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" class="topTips">
          <label>挂靠关系</label>
        </el-col>
      </el-row>
      <el-row v-if="$route.path.split('/')[2] === 'viewPartmem'">
        <el-col>
          <el-form-item>挂靠</el-form-item>
        </el-col>
      </el-row>
      <el-row v-else>
        <el-col>
          <el-form-item prop="serviceRevise.anchored">
            <el-radio v-model="form.serviceRevise.anchored" label="1">挂靠</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" class="topTips">
          <label>薪资构成</label>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="14">
          <el-form-item label="销售提成" prop="serviceRevise.saleRoyalty">
            <template v-if="$route.path.split('/')[2] === 'viewPartmem'">
             5%
            </template>
            <template v-else>
              <el-input
                v-model="form.serviceRevise.saleRoyalty"
                placeholder="请输入销售提成"
                style="width:160px"
              ></el-input>
              <span style="position:absolute;left:143px">%</span>
            </template>
            <p class="red">注：订单服务项目全部结束后计算提成</p>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="上门服务费" prop="serviceRevise.serviceFee">
            <template v-if="$route.path.split('/')[2] === 'viewPartmem'">
              ￥100
            </template>
            <template v-else>
              <el-input
                v-model="form.serviceRevise.serviceFee"
                placeholder="请输入上门服务费"
                style="width:230px"
              ></el-input>
              <span style="position:absolute;left:213px">￥</span>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="14">
          <el-form-item label="门店结算周期" required>
            <template v-if="$route.path.split('/')[2] === 'viewPartmem'">
            按周结算 每周 5
            </template>
            <template v-else>
              <el-col :span="10">
                <el-form-item prop="serviceRevise.sellCycle">
                  <el-select
                    v-model="form.serviceRevise.sellCycle"
                    placeholder="请选择结算周期"
                    style="width:160px"
                  >
                    <el-option label="周结" value="1"></el-option>
                    <el-option label="月结" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <span v-if="form.serviceRevise.sellCycle === '1'">每周</span>
                <span v-else>每月</span>
              </el-col>
              <el-col :span="11">
                <el-form-item prop="serviceRevise.cycleTime">
                  <el-input
                    v-model="form.serviceRevise.cycleTime"
                  ></el-input>
                </el-form-item>
              </el-col>
            </template>
            <p class="red">注：门店订单的结算周期</p>   
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="手工费">
            <el-table
            :data="form.serviceRevise.handFee"
            class="partTableMeminfo"
            border
            style="width: 100%" :header-cell-style="{background:'#EFF1F5'}">
              <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
				      <el-table-column align="center" prop="serviceTitle" label="项目名称">
                <template slot-scope="scope">
                  <el-row class="tableGoods">
                    <el-popover trigger="hover" placement="top">
                      {{scope.row.serviceTitle}}
                      <el-col slot="reference" class="myTitle">
                        <span>{{scope.row.serviceTitle | filterRow}}</span>
                      </el-col>
                    </el-popover>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="memberId" label="手工费">
                <template slot-scope="scope">
                  <template v-if="$route.path.split('/')[2] === 'viewPartmem'">
                  18
                  </template>
                  <template v-else>
                    <el-form-item :prop="'serviceRevise.handFee.'+scope.$index+'.rowhandFee'" :rules="rules.serviceRevise.handFee.rowhandFee">
                      <el-input
                        v-model="scope.row.rowhandFee"
                      ></el-input>
                    </el-form-item>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="生效日期" prop="serviceRevise.effectDate">
            <template v-if="$route.path.split('/')[2] === 'viewPartmem'">
            2018年11月28日
            </template>
            <template v-else>
              <el-date-picker
                v-model="form.serviceRevise.effectDate"
                type="date"
                placeholder="选择生效日期"
                value-format="timestamp"
                :picker-options="pickerOptions1"
              ></el-date-picker>
            </template>
            <p class="red">注：接单及薪资构成数据的生效日期，从0:00开始</p>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row class="btnOptions">
        <template v-if="$route.path.split('/')[2] === 'viewPartmem'">
          <el-button class="darkBtn" @click="closeTab">关闭</el-button>
        </template>
        <template v-else>
          <el-button class="darkBtn" @click="cancelTab">取消</el-button>
          <el-button class="redBtn" @click="submit">提交</el-button>
        </template>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { ServiceInfos, insertService, updateService } from "@/api";
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

let test = [];
for(let i = 0;i<20;i++){
    test.push({
        memberId:1
    })
}

export default {
  data() {
    /*验证手机号*/
    const isvalidateMobile = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^1[3456789]\d{9}$/.test(value) == false) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 数字
    const isvalidateNumber = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^[1-9]\d*$/.test(value) == false) {
          callback(new Error("请输入正整数"));
        } else if (Number(value) > 10000) {
          callback(new Error("排序不得大于10000！"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 价格
    const isvalidateMoney = (rule, value, callback) => {
      if (Number(value) || Number(value) == 0) {
        if (
          !Number.isInteger(Number(value)) &&
          value.toString().split(".")[1].length > 2
        ) {
          callback(new Error("超出两位小数"));
        } else if (Number(value) > 99999.99) {
          callback(new Error("超出金额范围"));
        } else if (Number(value) < 0) {
          callback(new Error("金额不能为负"));
        } else {
          callback();
        }
      } else {
        callback(new Error("金额格式错误"));
      }
    };
    // 提成
    const isvalidateRoyalty = (rule, value, callback) => {
      if (Number(value) || Number(value) == 0) {
        if (
          !Number.isInteger(Number(value)) &&
          value.toString().split(".")[1].length > 2
        ) {
          callback(new Error("不能超过两位小数"));
        } else if (Number(value) > 100) {
          callback(new Error("金额最大100"));
        } else if (Number(value) < 0) {
          callback(new Error("金额不能为负"));
        } else {
          callback();
        }
      } else {
        callback(new Error("只可以输入100以内的正数"));
      }
    };
    // 周结月结
    const isvalidateCycle = (rule, value, callback) => {
      if(this.form.serviceRevise.sellCycle == 1){
        // 周结 后方的文本框只能输入1-7，1代表周一，7代表周日
        if(/^[0-9]+$/.test(value) == false ){
          callback(new Error("只能输入1-7的正整数"));
        }else if(value > 7 || value < 1){
          callback(new Error("只能输入1-7,1代表周一,7代表周日"));
        }else{
          callback();
        }
      }else if(this.form.serviceRevise.sellCycle == 2){
        if(/^[0-9]+$/.test(value) == false ){
          callback(new Error("只能输入1-30的正整数"));
        }else if(value > 30 || value < 1){
          callback(new Error("只能输入1-30的正整数"));
        }else{
          callback();
        }
      }
    };
    return {
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
      },
      form: {
        serviceRevise: {
          tel:'',
          confirmTrue: this.$route.path.split('/')[2] !== 'addPartmem' ? ['1']:[],
          confirmCerti:this.$route.path.split('/')[2] !== 'addPartmem' ? ['1']:[],
          anchored:'1',
          saleRoyalty: "",
          serviceFee: "",
          sellCycle: "",
          cycleTime:'',
          handFee: test,
          effectDate:new Date().getTime()
        }
      },
      serviceReviseFlag:true,//默认有数据修改
      rules: {
        serviceRevise: {
          tel:[
            { required: true, message: "请输入手机号", trigger: "blur" },
            { validator: isvalidateMobile, trigger: "blur" }
          ],
          confirmTrue: [
            { required: true, message: "请确认本人与身份证信息是否一致", trigger: "change" }
          ],
          confirmCerti:[
            { required: true, message: "请确认手法、资质证书真实性、服务能力认可", trigger: "change" }
          ],
          saleRoyalty: [
            { required: true, message: "请输入销售提成", trigger: "blur" },
            { type: "number", validator: isvalidateRoyalty }
          ],
          serviceFee: [
            // 文本框必须小于等于门店配置的上门服务费。（上门单，给到调理师的费用，理论上不可以大于门店的上门服务费。）
            { required: true, message: "请输入上门服务费", trigger: "blur" },
            { type: "number", validator: isvalidateMoney }
          ],
          sellCycle: [
            { required: true, message: "请选择结算周期", trigger: "change" }
          ],
          cycleTime:[
            { required: true, message: "请输入结算周期", trigger: "blur" },
            {
              validator: isvalidateCycle,
              trigger: "blur"
            }
          ],
          handFee: {
            rowhandFee:[
              { required: true, message: "请输入手工费", trigger: "blur" },
              { type: "number", validator: isvalidateMoney }
            ]
          },
          effectDate:[
            { required: true, message: "请选择生效日期", trigger: "change" }
          ]
        }
      },
    };
  },
  created() {
    this.detailInfo();
  },
  computed: {
    options() {
      return this.$store.state.options;
    },
    activeIndex: {
      get() {
        return this.$store.state.activeIndex;
      },
      set(val) {
        this.$store.commit("set_active_index", val);
      }
    }
  },
  watch: {
    $route(to) {
      this.detailInfo();
    },
    'form.serviceRevise.confirmTrue'(val){
      if(val && val[0] == 1){
        this.$confirm("请一定要确保兼职人员身份信息的一致性~<p>确认之后不可修改！</p>", "提示", {
        dangerouslyUseHTMLString:true,
        confirmButtonText: "知道了",
        showCancelButton:false,
        type: "warning"
      })
        .then(() => {})
        .catch(action => {});
      }
    },
    'form.serviceRevise.confirmCerti'(val){
      if(val && val[0] == 1){
        this.$confirm("请确认兼职人员资质能力的真实性~<p>确认之后不可修改！</p>", "提示", {
        dangerouslyUseHTMLString:true,
        confirmButtonText: "知道了",
        showCancelButton:false,
        type: "warning"
      })
        .then(() => {})
        .catch(action => {});
      }
    }
  },
  methods: {
    detailInfo() {
      ServiceInfos({
        serviceId: this.$route.params.id
      }).then(res => {
        if (res.code == 1) {
          this.form = res.data;
          if (!this.form.serviceRevise) {
            this.serviceReviseFlag = false;
            this.form.serviceRevise = Object.assign(
              {},
              this.$options.data().form.serviceRevise
            );
          } else{
            if (!this.form.serviceRevise.confirmTrue) {
              this.form.serviceRevise.confirmTrue = [];
            }
            this.serviceReviseFlag = true;
          }
        }
      });
    },
    searchTel(){
      // 调取手机号
    },
    closeTab(){
      // 关闭
      this.$store.commit("delete_tabs", this.$route.path);
      // 设置当前激活的路由
      if (this.options && this.options.length >= 1) {
        this.$store.commit(
          "set_active_index",
          this.options[this.options.length - 1].route
        );
        this.$router.push({ path: this.activeIndex });
      }
    },
    cancelTab() {
      // 取消
      this.$confirm("确定要取消添加，取消后已填信息不保存", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "不取消了",
        cancelButtonText: "确定取消",
        type: "warning"
      })
        .then(() => {})
        .catch(action => {
          if (action === "cancel") {
            this.$message({
              type: "info",
              message: "已取消"
            });
            this.$refs.form.resetFields();
          }
        });
    },
    submit() {
      // 提交
      this.$refs.form.validate(valid => {
        if (valid) {
          // 操作
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.partMeminfo {
  width: 100%;
  overflow: hidden;
  padding: 50px 50px 70px;
  position: relative;
  .topTips {
    font-size: 17px;
    font-weight: bold;
    color: #444;
    margin: 20px 0;
  }
  .seize {
    height: 20px;
  }
  p.red{
    line-height: 24px;
  }
  .baseinfo{
    .el-row{margin-bottom: 0}
    .el-form-item {
      margin-bottom: 8px;
    }
  }
  .tableGoods {
    .myTitle {
      width: 100%;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .btnOptions {
    text-align: center;
    margin-top: 20px;
    .onSale {
      background: #2ecfa7;
      color: #fff;
    }
    .el-button {
      width: 135px;
      height: 46px;
    }
  }
}
</style>
<style>
.partTableMeminfo.el-table td{padding: 8px 0;}
.partTableMeminfo.el-table .cell{padding: 0}
.partTableMeminfo .el-form-item__content{line-height: 30px;}
.partTableMeminfo .el-input__inner{ width:40%;height: 30px;}
.partTableMeminfo .el-form-item__error{
  top: 4px;
  left: 176px;
}
</style>



// WEBPACK FOOTER //
// src/components/basicDataCenter/addPartmem.vue